import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PortalSelect from "../PortalSelect";
import BaseSelect from './BaseSelect';
import Value from './Value';

var Select =
/** @class */
function (_super) {
  tslib_1.__extends(Select, _super);

  function Select() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Select.prototype.render = function () {
    var _a = this.props,
        inPortal = _a.inPortal,
        props = tslib_1.__rest(_a, ["inPortal"]);

    var Component = inPortal ? PortalSelect : BaseSelect;
    return React.createElement(Component, tslib_1.__assign({}, props));
  };

  Select.propTypes = tslib_1.__assign({}, PortalSelect.propTypes, BaseSelect.propTypes, {
    inPortal: PropTypes.bool
  });
  Select.defaultProps = {
    inPortal: true
  };
  return Select;
}(Component); // Exposing default Value component for other teams so that they
// can enhance the existing one instead of building it from scratch


Select.Value = Value;
export default Select;

try {
  // @ts-ignore
  Select.__docgenInfo = {
    "description": "",
    "displayName": "Select",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}